import { signal } from "@preact/signals-react";

const countries = signal(false);
const provinces = signal(false); 
const cities = signal(false);
const districts = signal(false);

export {
    countries,
    provinces,
    cities,
    districts
}